import React, { memo, forwardRef } from "react";
const SvgReversibleReaction = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M22.293 8.293a1 1 0 011.414 0l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L25.586 15H12a1 1 0 110-2h13.586l-3.293-3.293a1 1 0 010-1.414zm-12.586 4a1 1 0 00-1.414 0l-5 5a1 1 0 000 1.414l5 5a1 1 0 001.414-1.414L6.414 19H20a1 1 0 100-2H6.414l3.293-3.293a1 1 0 000-1.414z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgReversibleReaction.displayName = "SvgReversibleReaction";
const MemoForwardRef = memo(SvgReversibleReaction);
export default MemoForwardRef;
